import {
    LogIn,
    LogOut,
    UserPlus,
    Mail,
    KeyRound,
    Wand2,
    Chrome,
    Link as LinkIcon,
    Boxes,
    Pencil,
    Archive,
    Undo2,
    Box,
    AlertTriangle,
    Eye,
    ShieldCheck,
    Ban,
    Check,
    ArrowUp,
    ArrowDown,
    UserMinus,
    Trash2,
    AlertCircle,
    Activity,
} from "lucide-react";

// Map BE audit `action` → human label + Lucide icon + tone.
// Tones: info | success | warn | danger | muted | default.
// Tones map to text colours in CSS.
export const AUDIT_VOCAB = {
    "auth.register": { label: "Registered", icon: UserPlus, tone: "info" },
    "auth.login.success": { label: "Signed in", icon: LogIn, tone: "info" },
    "auth.login.failed": {
        label: "Sign-in failed",
        icon: AlertTriangle,
        tone: "danger",
    },
    "auth.logout": { label: "Signed out", icon: LogOut, tone: "muted" },
    "auth.email_verification.requested": {
        label: "Verification email sent",
        icon: Mail,
        tone: "info",
    },
    "auth.email_verification.consumed": {
        label: "Email verified",
        icon: Check,
        tone: "success",
    },
    "auth.email_verification.failed": {
        label: "Email verification failed",
        icon: AlertTriangle,
        tone: "danger",
    },
    "auth.password_reset.requested": {
        label: "Password reset requested",
        icon: KeyRound,
        tone: "info",
    },
    "auth.password_reset.consumed": {
        label: "Password reset",
        icon: KeyRound,
        tone: "success",
    },
    "auth.password_reset.failed": {
        label: "Password reset failed",
        icon: AlertTriangle,
        tone: "danger",
    },
    "auth.magic_link.requested": {
        label: "Magic link requested",
        icon: Wand2,
        tone: "info",
    },
    "auth.magic_link.consumed": {
        label: "Signed in via magic link",
        icon: Wand2,
        tone: "success",
    },
    "auth.magic_link.failed": {
        label: "Magic link failed",
        icon: AlertTriangle,
        tone: "danger",
    },
    "auth.google.login": { label: "Signed in with Google", icon: Chrome, tone: "info" },
    "auth.google.linked": {
        label: "Linked Google account",
        icon: LinkIcon,
        tone: "info",
    },

    "sku.created": { label: "Created SKU", icon: Boxes, tone: "success" },
    "sku.updated": { label: "Updated SKU", icon: Pencil, tone: "info" },
    "sku.archived": { label: "Archived SKU", icon: Archive, tone: "muted" },
    "sku.restored": { label: "Restored SKU", icon: Undo2, tone: "info" },

    "pack.executed": { label: "Ran pack", icon: Box, tone: "default" },
    "pack.failed": { label: "Pack failed", icon: AlertTriangle, tone: "danger" },

    "admin.user.viewed": { label: "Viewed user", icon: Eye, tone: "muted" },
    "admin.user.verified": {
        label: "Verified email (admin)",
        icon: ShieldCheck,
        tone: "warn",
    },
    "admin.user.password_reset_triggered": {
        label: "Triggered password reset",
        icon: KeyRound,
        tone: "warn",
    },
    "admin.user.magic_link_triggered": {
        label: "Triggered magic link",
        icon: Wand2,
        tone: "warn",
    },
    "admin.user.disabled": { label: "Disabled account", icon: Ban, tone: "danger" },
    "admin.user.enabled": { label: "Re-enabled account", icon: Check, tone: "warn" },
    "admin.user.promoted": {
        label: "Promoted to admin",
        icon: ArrowUp,
        tone: "warn",
    },
    "admin.user.demoted": {
        label: "Demoted from admin",
        icon: ArrowDown,
        tone: "warn",
    },
    "admin.user.anonymised": {
        label: "Anonymised (GDPR)",
        icon: UserMinus,
        tone: "danger",
    },
    "admin.sku.viewed": { label: "Viewed SKU (admin)", icon: Eye, tone: "muted" },
    "admin.sku.deleted": {
        label: "Hard-deleted SKU",
        icon: Trash2,
        tone: "danger",
    },

    "system.email.send_failed": {
        label: "Email failed to send",
        icon: AlertCircle,
        tone: "danger",
    },
    "system.rate_limit.exceeded": {
        label: "Rate-limited",
        icon: AlertCircle,
        tone: "warn",
    },
};

export function formatAuditAction(action) {
    const meta = AUDIT_VOCAB[action];
    if (meta) return meta;
    // Fallback: prettify the action string itself.
    return {
        label: action.replace(/^[a-z]+\./, "").replace(/[._]/g, " "),
        icon: Activity,
        tone: "default",
    };
}

export function getAuditCategory(action) {
    if (!action) return "default";
    const dot = action.indexOf(".");
    return dot === -1 ? action : action.slice(0, dot);
}

export function relativeTime(iso) {
    if (!iso) return "";
    const now = Date.now();
    const t = new Date(iso).getTime();
    if (Number.isNaN(t)) return "";
    const diff = Math.max(0, Math.floor((now - t) / 1000));
    if (diff < 5) return "just now";
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
    return new Date(iso).toLocaleDateString();
}
